export default "/images/logo.png?582f187cdc99d29939dfebe69170547a";